// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-text-field__details {\n  margin-bottom: 8px;\n  margin-top: 5px;\n}\nbutton.v-btn--disabled {\n  color: #e0e0e0 !important;\n}", ""]);
// Exports
module.exports = exports;
